<script setup lang="ts">
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'
</script>

<template>
  <section class="relative overflow-hidden">
    <div class="pointer-events-none absolute -bottom-64 left-1/2 size-[var(--measure-900px)] -translate-x-1/2 rounded-full glow-mint" />
    <div class="relative mx-auto flex max-w-[var(--measure-1120px)] flex-col items-center gap-6 px-6 py-24 text-center">
      <h2 class="m-0 max-w-[var(--measure-640px)] text-[length:var(--measure-2p5714rem)] font-bold leading-[1.05] tracking-[-0.03em] text-pretty">Bring one folder of documents. Leave with a model that is yours.</h2>
      <p class="num m-0 text-[length:var(--measure-0p8571rem)] text-muted-foreground">A first run starts from one folder of Markdown or text files.</p>
      <div class="flex flex-wrap items-center justify-center gap-3">
        <NuxtLink to="/signup" class="no-underline hover:no-underline"><ActionButton size="lg" variant="gradient" label="Create an organisation"><template #trail><Icon name="arrow" /></template></ActionButton></NuxtLink>
        <NuxtLink to="/login" class="no-underline hover:no-underline"><ActionButton size="lg" label="Sign in" /></NuxtLink>
      </div>
    </div>
  </section>
</template>
